import React,{Component} from 'react';
import {Container} from 'reactstrap';
import {NavMenu} from './NavMenu';
import {ContactFormWidget} from './ContactFormWidget';
export class Layout extends Component {
  static displayName = Layout.name;

  constructor(props) {
    super(props);
    this.state = { setting: {}, hashtags: [], showTop: false };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    fetch('api/sitesetting')
      .then(r => r.ok ? r.json() : {})
      .then(setting => this.setState({ setting: setting || {} }))
      .catch(() => {});
    fetch('api/hashtag')
      .then(r => r.ok ? r.json() : [])
      .then(hashtags => this.setState({ hashtags: hashtags || [] }))
      .catch(() => {});
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var next = y > 400;
    if (next !== this.state.showTop) this.setState({ showTop: next });
  }

  render() {
    var s = this.state.setting || {};
    var hashtags = this.state.hashtags || [];
    var lineHref = s.line_id ? (s.line_id.startsWith('http') ? s.line_id : 'https://line.me/R/ti/p/' + encodeURIComponent(s.line_id)) : '';
    var socials = [
      { href: lineHref, icon: 'fab fa-line', color: '#06c755' },
      { href: s.facebook_url, icon: 'fab fa-facebook-f', color: '#1877f2' },
      { href: s.instagram_url, icon: 'fab fa-instagram', color: '#e4405f' },
      { href: s.youtube_url, icon: 'fab fa-youtube', color: '#ff0000' },
      { href: s.tiktok_url, icon: 'fab fa-tiktok', color: '#000' },
      { href: s.email ? 'mailto:' + s.email : '', icon: 'fas fa-envelope', color: '#dc3545' }
    ].filter(x => x.href);
    var p = ["ทัวร์ในประเทศ","ฟิลปปินล์","เยอรมัน","สวีเดน","ญี่ปุ่น","อินเดีย","สโลวาเกีย","เดนมาร์ก","จีน","มัลดีฟล์","สาธารณรัฐเชค","ตุรกี","เวียดนาม","บรูไน","สเปน","ดูไบ","พม่า","เนปาล","อังกฤษ","จอร์เจีย","กัมพูชา","โปรตุเกส","เบลเยีียม","แอฟฟรีกาใต้","มาเลเซีย","โครเอเชีย","เนเธอร์แลนด์","สหรัฐอเมริกา","สิงค์โปร์","อิตาลี","ลักเซมเบิร์ก","แคนนาดา","ไต้หวัน","สวิตเซอร์แลนด์","รัสเซีย","อียิปต์","เกาหลี","ฝรั่งเศส","ฟินแลนด์","ออสเตรเลีย","ฮ่องกง","ออสเตรีย","ไอซ์แลนด์","นิวซีแลนด์","อินโดนีเซีย","ฮังการี","นอร์เวย์",];
    
    var d = new Date();
    var year = d.getFullYear();
    return (
      <div>
        <NavMenu />
        <div className="container-fulid">
          {this.props.children}</div>
        <ContactFormWidget />
        <div
          onClick={() => {
            try { window.scrollTo({ top: 0, behavior: 'smooth' }); }
            catch { window.scrollTo(0, 0); }
          }}
          title="กลับด้านบน"
          style={{
            position: 'fixed', right: 28, bottom: 30,
            width: 44, height: 44, borderRadius: '50%',
            background: 'rgba(0,0,0,0.55)', color: '#fff',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer', zIndex: 999997, boxShadow: '0 4px 14px rgba(0,0,0,0.25)',
            opacity: this.state.showTop ? 1 : 0,
            pointerEvents: this.state.showTop ? 'auto' : 'none',
            transform: this.state.showTop ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 0.25s ease, transform 0.25s ease'
          }}>
          <i className="fa fa-chevron-up"></i>
        </div>
        <footer style={{ background: 'linear-gradient(180deg, #c82333 0%, #9d1a26 100%)', color: '#fff', marginTop: 40 }}>
          <div className="container" style={{ padding: '48px 20px 24px' }}>
            <div className="row g-4">
              {/* Brand + address */}
              <div className="col-lg-4 col-md-6">
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 18 }}>
                  <img src="/images/ANT_LOGO.png" alt="ANT" style={{ height: 50, background: '#fff', borderRadius: 8, padding: 4 }} />
                  <div>
                    <div style={{ fontSize: 20, fontWeight: 800, color: '#fff', lineHeight: 1.1 }}>{s.company_name || 'ANT JOURNEY HOUSE'}</div>
                    <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)', marginTop: 2 }}>CO., LTD.</div>
                  </div>
                </div>

                {s.address && (
                  <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', marginBottom: 10 }}>
                    <i className="fas fa-map-marker-alt" style={{ color: '#ffd966', marginTop: 4, width: 16 }}></i>
                    <div style={{ fontSize: 13, lineHeight: 1.6, color: 'rgba(255,255,255,0.85)', whiteSpace: 'pre-line' }}>{s.address}</div>
                  </div>
                )}
                {s.phone && (
                  <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 8 }}>
                    <i className="fas fa-phone" style={{ color: '#ffd966', width: 16 }}></i>
                    <a href={'tel:' + s.phone} style={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', textDecoration: 'none' }}>{s.phone}</a>
                  </div>
                )}
                {s.email && (
                  <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 20 }}>
                    <i className="fas fa-envelope" style={{ color: '#ffd966', width: 16 }}></i>
                    <a href={'mailto:' + s.email} style={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', textDecoration: 'none' }}>{s.email}</a>
                  </div>
                )}

                {s.license_no && (
                  <div style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.25)', borderRadius: 8, padding: '10px 14px', display: 'inline-flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
                    <img src="/images/img-regis.png" alt="DBD" style={{ height: 40, borderRadius: 4 }} />
                    <div>
                      <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)' }}>เลขที่ใบอนุญาต</div>
                      <div style={{ fontSize: 18, fontWeight: 800, color: '#fff' }}>{s.license_no}</div>
                    </div>
                  </div>
                )}

                {s.map_lat && s.map_lng && (
                  <div style={{ borderRadius: 10, overflow: 'hidden', boxShadow: '0 4px 14px rgba(0,0,0,0.25)', border: '2px solid rgba(255,255,255,0.2)' }}>
                    <iframe title="map" width="100%" height="200" frameBorder="0" style={{ border: 0, display: 'block' }}
                      src={`https://maps.google.com/maps?q=${encodeURIComponent(s.map_lat)},${encodeURIComponent(s.map_lng)}&z=${s.map_zoom || 15}&output=embed`}
                      loading="lazy"></iframe>
                    <a href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(s.map_lat)},${encodeURIComponent(s.map_lng)}`} target="_blank" rel="noopener noreferrer"
                      style={{ display: 'block', background: 'rgba(0,0,0,0.25)', color: '#fff', padding: '8px 12px', fontSize: 12, textDecoration: 'none', textAlign: 'center', fontWeight: 600 }}>
                      <i className="fas fa-directions"></i> นำทาง (Get Directions)
                    </a>
                  </div>
                )}
              </div>

              {/* Quick links */}
              <div className="col-lg-3 col-md-6">
                <div style={{ fontSize: 15, fontWeight: 700, color: '#fff', marginBottom: 16, paddingBottom: 8, borderBottom: '2px solid #fff', display: 'inline-block' }}>เมนูลัด</div>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {[
                    { to: '/', label: 'หน้าแรก', icon: 'fas fa-home' },
                    { to: '/programs/search', label: 'โปรแกรมท่องเที่ยว', icon: 'fas fa-suitcase-rolling' },
                    { to: '/programs/search?hashtag=PROMOTION', label: 'โปรโมชั่นพิเศษ', icon: 'fas fa-tags' },
                    { to: '/group-request', label: 'จัดกรุ๊ปส่วนตัว', icon: 'fas fa-users' },
                    { to: '/aboutUs', label: 'เกี่ยวกับเรา', icon: 'fas fa-info-circle' }
                  ].map((l, i) => (
                    <li key={i} style={{ marginBottom: 10 }}>
                      <a href={l.to} style={{ color: 'rgba(255,255,255,0.85)', textDecoration: 'none', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8, transition: 'color 0.2s' }}
                        onMouseEnter={e => e.currentTarget.style.color = '#ffd966'}
                        onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.85)'}>
                        <i className={l.icon} style={{ fontSize: 11, width: 14 }}></i>
                        <span>{l.label}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Hashtags */}
              <div className="col-lg-5 col-md-12">
                <div style={{ fontSize: 15, fontWeight: 700, color: '#fff', marginBottom: 16, paddingBottom: 8, borderBottom: '2px solid #fff', display: 'inline-block' }}>#HASHTAG</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  {hashtags.length === 0 ? (
                    <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)' }}>ยังไม่มี hashtag — เพิ่มที่ Console &gt; Tools &gt; Hashtag หน้าบ้าน</div>
                  ) : hashtags.map((h, i) => (
                    <a key={i} href={`/programs/search?hashtag=${encodeURIComponent(h.keyword || h.label)}`}
                      style={{ fontSize: 12, color: '#fff', background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.25)', padding: '4px 12px', borderRadius: 20, textDecoration: 'none', transition: 'all 0.2s', fontWeight: 600 }}
                      onMouseEnter={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#c82333'; e.currentTarget.style.borderColor = '#fff'; }}
                      onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.15)'; e.currentTarget.style.color = '#fff'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.25)'; }}>
                      <span style={{ opacity: 0.7 }}>#</span>{h.label}
                    </a>
                  ))}
                </div>

                {socials.length > 0 && <div style={{ fontSize: 15, fontWeight: 700, color: '#fff', marginTop: 28, marginBottom: 14, paddingBottom: 8, borderBottom: '2px solid #fff', display: 'inline-block' }}>ช่องทางติดต่อ</div>}
                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                  {socials.map((s, i) => (
                    <a key={i} href={s.href} target="_blank" rel="noopener noreferrer"
                      style={{ width: 40, height: 40, borderRadius: '50%', background: 'rgba(255,255,255,0.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', textDecoration: 'none', transition: 'all 0.2s' }}
                      onMouseEnter={e => { e.currentTarget.style.background = s.color; e.currentTarget.style.transform = 'translateY(-3px)'; }}
                      onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.18)'; e.currentTarget.style.transform = 'translateY(0)'; }}>
                      <i className={s.icon}></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div style={{ background: 'rgba(0,0,0,0.25)', padding: '14px 20px', textAlign: 'center', color: 'rgba(255,255,255,0.85)', fontSize: 12, borderTop: '1px solid rgba(255,255,255,0.15)' }}>
            Copyright © {year} {s.company_name || 'ANT Journey House Co., Ltd.'} All rights reserved.
          </div>
        </footer>
      </div>
    );
  }
}
